import React from 'react';

export function Group({ children }) {
  return <div className="Form__group">{children}</div>;
}
